import { render, staticRenderFns } from "./wxmini.vue?vue&type=template&id=53ae1778&"
import script from "./wxmini.vue?vue&type=script&lang=js&"
export * from "./wxmini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports